import { Link } from 'react-router-dom';

const TermsAndConditions = () => (
  <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
    <Link to="/">← Back to Home</Link>
    <h1>Terms And Conditions</h1>
    <p>Last Updated: December 2025</p>
    <section>
   <h2>1. Agreement to Terms</h2>
By downloading or using "Remind Me of My Scriptures" (the "App"), you agree to these Terms and Conditions. These terms are a legal agreement between you and the developer. If you do not agree, do not use the App.

<h2>2. Description of Service</h2>
The App is a tool for personal scripture study, organization, and memorization. It is provided "as-is" and is currently free of charge. There are no paid products, subscriptions, or services within the App.

<h2>3. User-Generated Content & Data</h2>
Local Storage: All scriptures, categories, and progress you add are stored strictly on your device.

No Backups: We do not host your data on our servers. We cannot recover lost data for you. You are solely responsible for using the "Export" feature to back up your own library.

Responsibility: you are responsible for any content you manually input or import into the App.

<h2>4. Google Analytics & Location</h2>
By using the App, you acknowledge that we use Google Analytics to track anonymized activity and general geographic location to improve App performance. No personal identification is linked to this tracking.

<h2>5. Prohibited Conduct</h2>
You agree not to:

Attempt to decompile or reverse-engineer the App.

Use the App for any illegal or unauthorized purpose.

Interfere with the App's security features.

<h2>6. Limitation of Liability</h2>
To the maximum extent permitted by law, the developer shall not be liable for any damages (including loss of data or profit) arising out of the use or inability to use the App, even if notified of the possibility of such damage.

<h2>7. Governing Law</h2>
These Terms are governed by and construed in accordance with the laws, without regard to its conflict of law principles.

<h2>8. Contact</h2>
For any questions regarding these Terms, please contact: Email: jspiritcodedeveloper@gmail.com </section>
  </div>
);

export default TermsAndConditions;